import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import Ripple from 'vuetify/lib/directives/ripple';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _setup.iconClasses || _setup.statuses.isLoading
    ? _c(
        "div",
        {
          directives: [
            {
              def: Ripple,
              name: "ripple",
              rawName: "v-ripple",
              value: _setup.statuses.isFail,
              expression: "statuses.isFail",
            },
          ],
          staticClass:
            "status-icon rounded-circle d-flex align-center justify-center bg-gray-0",
          class: {
            "cursor-pointer": _setup.statuses.isFail,
          },
          attrs: {
            "data-qa": "status_icon",
            "data-qa-status": _setup.props.status,
          },
          on: {
            click: function ($event) {
              _setup.statuses.isFail ? _setup.emit("click") : null
            },
          },
        },
        [
          _setup.statuses.isLoading
            ? _c(VProgressCircular, {
                attrs: {
                  width: "2",
                  color: "primary",
                  size: "20",
                  value: _vm.progressValue,
                  indeterminate:
                    _vm.progressValue === undefined ||
                    Number(_vm.progressValue) >= 100,
                },
              })
            : _c("span", { class: _setup.iconClasses }),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }